
    <v-public-bottom-gradient-wrapper>
      <div class="max-w-4xl mx-auto p-4 space-y-6">
        <div class="text-center space-y-2">
          <h2 class="text-3xl font-bold text-white">
            {{ 'onboarding.incident.localizationSetup.title' | transloco }}
          </h2>
          <p class="text-gray-300 text-lg">
            {{
              'onboarding.incident.localizationSetup.description' | transloco
            }}
          </p>
        </div>

        <div class="grid grid-cols-1">
          <div>
            <div class="bg-white/5 backdrop-blur-lg rounded-lg p-6 my-2 space-y-6">          
              <form [formGroup]="localeForm" class="flex flex-col space-y-6">
                <v-input-field
                  label="{{
                    'onboarding.incident.localizationSetup.language.label'
                      | transloco
                  }}"
                  fControlName="language">
                  <v-dropdown
                    fControlName="language"
                    [options]="languageOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'onboarding.incident.localizationSetup.language.placeholder'
                        | transloco
                    }}"
                    testId="language-dropdown">
                  </v-dropdown>
                </v-input-field>

                <v-input-field
                  label="{{
                    'onboarding.incident.localizationSetup.timezone.label'
                      | transloco
                  }}"
                  fControlName="timezone">
                  <v-dropdown
                    fControlName="timezone"
                    [options]="timezoneOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'onboarding.incident.localizationSetup.timezone.placeholder'
                        | transloco
                    }}"
                    testId="timezone-dropdown">
                  </v-dropdown>
                </v-input-field>
              </form>

              <!-- Preview Section -->
              <div class="bg-white/5 rounded-lg p-4">
                <h3 class="text-white font-medium mb-2">
                  <i class="pi pi-eye mr-2 text-blue-400"></i>
                  {{
                    'onboarding.incident.localizationSetup.preview.title'
                      | transloco
                  }}
                </h3>
                <div class="space-y-2 text-sm">
                  <div class="flex justify-between">
                    <span class="text-gray-300">
                      {{
                        'onboarding.incident.localizationSetup.preview.language'
                          | transloco
                      }}:</span
                    >
                    <span class="text-white">{{
                      getSelectedLanguageLabel()
                    }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-300">
                      {{
                        'onboarding.incident.localizationSetup.preview.timezone'
                          | transloco
                      }}:</span
                    >
                    <span class="text-white">{{
                      getSelectedTimezoneLabel()
                    }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-300">
                      {{
                        'onboarding.incident.localizationSetup.preview.currentTime'
                          | transloco
                      }}:</span
                    >
                    <span class="text-white">{{ getCurrentTime() }}</span>
                  </div>
                </div>
              </div>
              <div class="justify-end flex">
                <v-button-v2
                  (press)="saveLocalePreferences()"
                  icon="pi pi-plus"
                  [disabled]="!localeForm.valid">
                  {{
                    'onboarding.incident.localizationSetup.savePreferences'
                      | transloco
                  }}
                </v-button-v2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-public-bottom-gradient-wrapper>